import { useAppContext } from 'hooks/useAppContext';
import { useOutletContext, useParams } from 'react-router-dom';
import { ITruckerProfileContextProps } from 'types';

const useTruckerProps = () => {
  const {
    state: {
      truckerProfile: { truckerProps },
    },
  } = useAppContext();

  const { truckerId, freightId } = useParams();
  const outletDataTest = useOutletContext<ITruckerProfileContextProps>();

  if (!truckerProps && (truckerProps?.truckerId === null || truckerProps?.truckerId === undefined) && !outletDataTest) {
    return {};
  }

  const getProperty = (name: string, alternative: unknown = undefined) => {
    if (truckerProps?.[name] !== undefined) return truckerProps[name];

    // eslint-disable-next-line
    const outletData: { [name: string]: any } = outletDataTest;

    if (outletData?.[name] !== undefined) return outletData[name];

    return alternative;
  };

  return {
    truckerId: getProperty('truckerId', truckerId),
    freightId: getProperty('freightId', freightId),
    lastLocation: getProperty('lastLocation'),
    dispatchToCaller: getProperty('dispatchToCaller'),
    freight: getProperty('freight'),
    hasDrawer: getProperty('hasDrawer', false),
    portalName: getProperty('portalName', 'portal-trucker-profile'),
    eventsSource: getProperty('eventsSource', 'lista-motorista'),
    hideProfileToasts: getProperty('hideProfileToasts', false),
    hideStickyHeader: getProperty('hideStickyHeader', false),
    dispatchEventOnStart: getProperty('dispatchEventOnStart', false),
    onClose: getProperty('onClose', /* istanbul ignore next */ () => false),
    isOpenSearch: getProperty('isOpenSearch', false),
    truckerSearchedBy: getProperty('truckerSearchedBy', null),
    initialTruckerData: getProperty('initialTruckerData'),
    initialContactListFeatureData: getProperty('initialContactListFeatureData'),
    showDepositInfo: getProperty('showDepositInfo', false),
  };
};

export { useTruckerProps };
